export const userQueryKeys = {
  all: ["user"],
  byId: (id: string) => [...userQueryKeys.all, "id", id],
};
